export enum Log {
  ALL = "*",
  ERROR = "error",
  WARN = "warn",
  CHAT = "chat",
  ACCOUNT = "account",
  AGENT = "agent",
  MEMBER = "member",
  AI = "ai",
  API = "api",
  ASYNC_FMS = "async-fms",
  AUTH = "auth",
  BRAINS = "brains",
  BULL = "BULL",
  SEQUENCES = "sequences",
  BULL_REDIS = "redis",
  CONVERSATIONS = "conversations",
  DATABASE = "database",
  EMAIL = "email",
  ESCALATIONS = "escalations",
  FACEBOOK_MESSENGER = "facebook-messenger",
  FMS_SERVICE = "fms",
  GOOGLE = "google",
  LOCATIONS = "locations",
  MESSAGE_ROUTER = "message-router",
  NODE_HANDLER = "node-handler",
  NODE_ROUTER = "node-router",
  NOTIFICATIONS = "notifications",
  POSTAL_CODE_MANAGER = "postal-code-manager",
  QNODE = "qnode",
  QUESTS = "quests",
  REDIS = "redis",
  REVIEWS = "reviews",
  ROLES = "roles",
  SPOT = "spot",
  SMS = "sms",
  SMS_GROUP = "sms-group",
  SYNC_FMS = "sync-fms",
  USER_MERGE = "user-merge",
  USER_VARS = "user-vars",
  USERS = "users",
  WHATSAPP = "whatsapp",
  VOICE = "voice",
  WEBSOCKET = "websocket",
  KIEM = "kiem",
  SESSIONS = "sessions",
  VARS = "vars",
  UTIL = "util",
}
